import React from 'react'

import LoginImage from '../../assets/images/login.svg';
import Logo1 from '../../assets/images/logo.svg'


import "./index.css"

interface PropsType {
  children: JSX.Element | JSX.Element[]
}

export default function PublicBackground(props:PropsType) {
  return (
  <div className="l-container">
      <div className="login-image" style={{backgroundImage: `url(${LoginImage})` }}></div>
      <div className="login">
      <img className="login-logo"  src={Logo1} alt="" />
        {props.children}
      </div>
  </div>
  )
}
